import React, {FC} from 'react'

export const SelectIcon: FC = () => (
    <svg className='canvas-toolbar__icon' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
        <path d='M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z'/>
        <path d='M13 13l6 6'/>
    </svg>
)
